interface AddedTags {
  scriptTags: {
    src: string
    addEventListener: (
      name: string,
      callback: () => void,
      options: { once: boolean },
    ) => void
  }[]
}

export const handleChangeClientState =
  (scriptSrc: string, callback: () => void) =>
  (_: any, addedTags: AddedTags) => {
    if (addedTags && addedTags.scriptTags) {
      const script = addedTags.scriptTags.find(({ src }) => src === scriptSrc)
      if (script) {
        script.addEventListener('load', callback, { once: true })
      }
    }
  }
